import { Spinner } from 'components/ui';
import { LogoMark } from 'components/brand/Logo';
import { cx } from 'utils';

/**
 * LoadingScreen — full-viewport branded loading state. Used by route guards
 * while auth resolves and during heavy async boots.
 *
 * @param {string}  [message='Loading…']
 * @param {boolean} [branded=true]  Show the animated LearnX mark.
 */
export default function LoadingScreen({ message = 'Loading…', branded = true, className = '' }) {
  return (
    <div
      className={cx(
        'flex min-h-screen flex-col items-center justify-center gap-6 bg-canvas',
        className
      )}
    >
      {branded ? (
        <div className="relative">
          <div className="absolute -inset-4 -z-10 animate-glow-pulse rounded-[2rem] bg-brand-200/40 blur-3xl" />
          <LogoMark size={52} className="animate-float drop-shadow-[0_4px_16px_rgba(79,70,229,0.28)]" />
        </div>
      ) : (
        <Spinner size={36} />
      )}
      <div className="flex items-center gap-2.5 text-sm font-medium text-slate-500">
        {branded && <Spinner size={14} />}
        <span>{message}</span>
      </div>
    </div>
  );
}
